<template>
  <div class="cooperation">
    <h1>
      cooperation
    </h1>
  </div>
</template>

<script>
export default {
  name: 'cooperation'
}
</script>

<style>

</style>